import { render, staticRenderFns } from "./FolderMultipleImage.vue?vue&type=template&id=497205fa&"
import script from "./FolderMultipleImage.vue?vue&type=script&lang=js&"
export * from "./FolderMultipleImage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports